module.exports = __webpack_public_path__ + "static/media/comment.b51be12f.svg";